"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogHeader = void 0;
var DialogHeader_1 = __importDefault(require("./DialogHeader"));
exports.DialogHeader = DialogHeader_1.default;
exports.default = DialogHeader_1.default;
//# sourceMappingURL=index.js.map